// BullshipPrivacyPolicy.jsx
import React from "react";

function Style() {
  return (
    <style>{`
      .policy { max-width: 800px; margin: 0 auto; padding: 20px; font-family: Roboto, Helvetica, Arial, sans-serif; line-height: 1.6; color: #ffffff; }
      .policy h1 { font-size: 2rem; margin: 0 0 4px; }
      .policy header p { margin: 4px 0 0; }
      .policy .section { margin-top: 24px; }
      .policy h2 { font-size: 1.125rem; margin: 0 0 8px; }
      .policy .bullets { padding-left: 1.25rem; margin: 8px 0 0; }
      .policy .bullets li { margin: 6px 0; }
      .policy a { color: #ffffff; text-decoration: underline; text-underline-offset: 3px; }
    `}</style>
  );
}

function Section({ number, title, children }) {
  return (
    <section className="section">
      <h2>{number}. {title}</h2>
      {children}
    </section>
  );
}

function Bullets({ items }) {
  return (
    <ul className="bullets">
      {items.map((text, i) => <li key={i}>{text}</li>)}
    </ul>
  );
}

export default function BullshipPrivacyPolicy() {
  return (
    <div className="policy" style={{marginTop: 80}}>
      <Style />

      <header>
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 2025/08/11</p>
      </header>

      <p>
        Snowtail (“we,” “our,” or “us”) respects your privacy. This Privacy Policy explains how we collect, use,
        and protect information when you play <strong>Bullship</strong> on Amazon Luna.
      </p>

      <Section number={1} title="Information We Collect">
        <Bullets
          items={[
            "We do not collect personally identifiable information such as your name, email, or address.",
            "Gameplay and usage statistics — e.g., number of players, how long you play, when you leave the game.",
            "Crash and performance reports — to help us fix bugs and improve the game.",
            "Motion detection data — to support gesture-based gameplay mechanics (no raw sensor recordings are stored).",
            "Aggregated analytics data — via third-party tools such as Unity Analytics.",
          ]}
        />
        <p>All information is collected anonymously and cannot be used to personally identify you.</p>
      </Section>

      <Section number={2} title="How We Use the Information">
        <Bullets
          items={[
            "Improve gameplay experience and performance.",
            "Identify and fix crashes or technical issues.",
            "Understand how players interact with the game.",
            "Enhance existing features and develop new ones.",
          ]}
        />
      </Section>

      <Section number={3} title="Third-Party Services">
        <p>
          We may use Unity Analytics or similar services to collect aggregated gameplay data. These services may
          collect and process anonymous information in accordance with their own privacy policies:
        </p>
        <Bullets
          items={[
            <a
              key="unity-pp"
              href="https://unity.com/legal/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Unity Privacy Policy
            </a>,
          ]}
        />
      </Section>

      <Section number={4} title="Data Storage & Security">
        <p>
          We store only aggregated and anonymous data. We take reasonable technical and organizational measures to
          protect all collected data from unauthorized access, use, or disclosure.
        </p>
      </Section>

      <Section number={5} title="Children’s Privacy">
        <p>
          Bullship is not directed at children under the age of 13. We do not knowingly collect personal
          information from children. If you believe we have inadvertently collected such data, please contact us
          so we can delete it.
        </p>
      </Section>

      <Section number={6} title="Your Rights">
        <p>
          Depending on your location, you may have rights under laws such as the GDPR or CCPA to access, delete,
          or restrict the processing of your data. Since our data is anonymized, it cannot be linked back to
          individual players.
        </p>
      </Section>

      <Section number={7} title="Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Updates will be posted at the URL listed below with
          a revised effective date.
        </p>
      </Section>

      <Section number={8} title="Contact Us">
        <p>
          If you have any questions about this Privacy Policy, please contact:
          {" "}
          <a href="mailto:info@snowtailgames.com">info@snowtailgames.com</a>
        </p>
      </Section>
    </div>
  );
}
